import store from "../store";
import Constants from "../config/constants";
import { serviceDoctorsBrandDetails, serviceDoctorsDataInfo } from "../services/DoctorsData.service";

export const FETCH_INIT = "FETCH_INIT_DOCTORS_DATA";
export const FETCHED = "FETCHED_DOCTORS_DATA";
export const FETCHED_FAIL = "FETCHED_FAIL_DOCTORS_DATA";
export const FETCHED_FILTER = "FETCHED_FILTER_DOCTORS_DATA";
export const FETCH_NEXT = "FETCH_NEXT_DOCTORS_DATA";
export const FILTER = "FILTER_DOCTORS_DATA";
export const RESET_FILTER = "RESET_FILTER_DOCTORS_DATA";
export const SET_SORTING = "SET_SORTING_DOCTORS_DATA";
export const SET_FILTER = "SET_FILTER_DOCTORS_DATA";
export const SET_PAGE = "SET_PAGE_DOCTORS_DATA";
export const CHANGE_PAGE = "CHANGE_PAGE_DOCTORS_DATA";
export const CHANGE_STATUS = "CHANGE_STATE_DOCTORS_DATA";
export const SET_SERVER_PAGE = "SET_SERVER_PAGE_DOCTORS_DATA";
export const CREATE_DATA = "CREATE_DOCTORS_DATA";
export const UPDATE_DATA = "UPDATE_DOCTORS_DATA";
export const DELETE_ITEM = "DELETE_DOCTORS_DATA";

export function actionFetchDoctors(index = 1, sorting = {}, filter = {}) {
  const request = serviceDoctorsDataInfo({
    index,
    row: sorting.row,
    order: sorting.order,
    ...filter,
  });
  return (dispatch) => {
    dispatch({ type: FETCH_INIT, payload: null });
    request.then((data) => {
      dispatch({ type: SET_FILTER, payload: filter });
      dispatch({ type: SET_SORTING, payload: sorting });
      if (!data.error) {
        dispatch({ type: FETCHED, payload: { data: data.data, page: index } });
        dispatch({ type: SET_SERVER_PAGE, payload: index });
        if (index == 1) {
          dispatch({ type: CHANGE_PAGE, payload: index - 1 });
        }
      } else {
        dispatch({ type: FETCHED_FAIL, payload: null });
      }
    });
  };
}


export function actionSetPageDoctors(page, form) {
  const stateData = store.getState().doctors_data;
  const currentPage = stateData.currentPage;
  const totalLength = stateData.all.length;
  const sortingData = stateData.sorting_data;
  const query = stateData.query;
  const queryData = stateData.query_data;
  const serverPage = stateData.serverPage;
  
  if (totalLength <= (page + 1) * Constants.DEFAULT_PAGE_VALUE) {
    store.dispatch(
      actionFetchDoctors(serverPage + 1, sortingData, {
        query,
        query_data: queryData,
        ...form
      })
    );
  }

  console.log(currentPage, totalLength);
  return {
    type: CHANGE_PAGE,
    payload: page,
  };
}
